// ----------------------------------------------------------------------
// <copyright file="Izenda.Sidebar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var ScrollBox = require('../controls/Izenda.ScrollBox');

  var classnames = require('classnames');

  var SIDEBAR_EXPANDED = 'expanded';
  var SIDEBAR_COLLAPSED = 'collapsed';
  const { isNil } = require('lodash/fp');
  var Sidebar = React.createClass({
    propTypes: {
      isHiddenOnCollapsed: React.PropTypes.bool,
      isExpanded: React.PropTypes.bool,
      hasScrollBox: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        hasScrollBox: true
      };
    },

    getInitialState: function() {
      return {
        isExpanded: true
      };
    },

    componentWillMount: function() {
      this.updateExpanded(this.props.isExpanded);
    },

    componentWillReceiveProps: function(nextProps) {
      this.updateExpanded(nextProps.isExpanded);
    },

    updateExpanded: function(isExpanded) {
      if (!isNil(isExpanded)) {
        this.setState({ isExpanded: isExpanded });
      }
    },

    toggleSidebar: function() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    },

    getCollapsibleStatus: function() {
      return this.state.isExpanded ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;
    },

    render: function() {
      var classes = classnames(this.getCollapsibleStatus(), {
        'izenda-Sidebar': true
      });

      return (
        <div className={classes} aria-expanded="false">
          <div className="u_marginLeft u_fullHeight">{this.renderContent()}</div>
        </div>
      );
    },

    renderContent: function() {
      var props = this.props;
      var isHidden = props.isHiddenOnCollapsed && !this.state.isExpanded;
      var className = classnames(this.props.className, this.getCollapsibleStatus());

      var content = (
        <div>
          {this.renderCollapsibleSection()}
          {!isHidden && <div className={className}>{this.props.children}</div>}
        </div>
      );

      return this.props.hasScrollBox ? (
        <ScrollBox shouldInjectScrollCallbackToChild={false}>{content}</ScrollBox>
      ) : (
        content
      );
    },

    renderCollapsibleSection: function() {
      return (
        <div className="collapsible">
          <div className={classnames('izenda-NavIcon', this.getCollapsibleStatus())} onClick={this.toggleSidebar}>
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
        </div>
      );
    }
  });
  module.exports = Sidebar;
})();



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.Sidebar.jsx